// Main page

import HeadedBlock from '@/components/DybrComponents/HeadedBox';
import {
  Section,
  SectionLargerBlock,
  SectionSmallerBlock
} from '@/components/DybrComponents/Section';
import { DybrPageWrapper } from '@/components/DybrComponents/Wrappers';
import { useActiveProfile } from '@/store/localStorage/useTokenState';
import { selectActiveProfileAugmented } from '@/store/user/selectors/selectActiveProfileAugmented';
import theme from '@/styles/DybrTheme';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import NewsBlock from './components/DybrNews';
import { InterestingList } from './components/InterestingList';
import { loggedInInfo } from './components/StaticTexts';

const ActionBlock = styled.div`
  padding: 0 0 0 100px;
  @media (max-width: 800px) {
    padding: 0;
  }
`;

const ButtonLink = styled.div`
  a {
    display: block;
    background: ${props => props.background || props.theme.backgroundLighter};
    color: ${props => props.color || props.theme.text} !important;
    max-width: ${props => props.width};
    margin: 25px auto;
    padding: 10px 15px;
    text-align: center;
    text-transform: lowercase;
    text-decoration: none;
    @media (max-width: 600px) {
      font-size: 16px;
    }
  }
`;

export function MainLoggedIn() {
  const [scroll, setScroll] = useState(false);
  const { activeProfileId } = useActiveProfile();
  const activeProfile = useSelector(state =>
    selectActiveProfileAugmented(state, { activeProfileId })
  );

  useEffect(() => {
    setScroll(true);
    window.addEventListener('scroll', scrollFalse);
    document.title = 'Дыбр';
    return () => {
      window.removeEventListener('scroll', scrollFalse);
    };
    // eslint-disable-next-line
  }, []);

  const scrollFalse = () => {
    setScroll(false);
    window.removeEventListener('scroll', scrollFalse);
  };

  if (scroll) window.scrollTo(0, 0);

  if (!activeProfile) return null;

  return (
    <DybrPageWrapper>
      <Section>
        <SectionLargerBlock>
          <NewsBlock height={'272px'} />
        </SectionLargerBlock>
        <SectionSmallerBlock>
          <ActionBlock data-testid="salutation-section">
            <HeadedBlock title="Привет!" dark>
              <div>
                Спасибо, что зашли на огонёк! Держите быстрые ссылки на самое
                важное.
              </div>
              <ButtonLink>
                <Link to={`/settings`}>К настройкам</Link>
              </ButtonLink>
              <ButtonLink>
                <Link to="/feed">ЧИТАТЬ ОБЩУЮ ЛЕНТУ</Link>
              </ButtonLink>
              <ButtonLink>
                <Link to={`/blog/${activeProfile.blogSlug}/0/edit`}>
                  Написать новую запись
                </Link>
              </ButtonLink>
            </HeadedBlock>
          </ActionBlock>
        </SectionSmallerBlock>
      </Section>
      <Section
        backgroundColor={theme.backgroundLighter}
        withBackground
        title="Важная информация"
        lastSection
      >
        <InterestingList data={loggedInInfo} />
      </Section>
    </DybrPageWrapper>
  );
}
